// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uKNz","top":"styles_top__s8Hi4","left":"styles_left__2_nxh","description":"styles_description__2WfoD"};